/*! License details at fancyapps.com/license */
const e=(e,o)=>{let t=[];return e.childNodes.forEach((e=>{e.nodeType!==Node.ELEMENT_NODE||o&&!e.matches(o)||t.push(e)})),t};export{e as getDirectChildren};
